export default "__VITE_ASSET__4SwJA9sv__"